export enum PromotionContestRewardType {
  Sapphires = 'sapphires',
  Hearts = 'hearts',
}

export enum PromotionContestDeliveryType {
  Immediate = 'immediate',
  Mail = 'mail',
}

export interface PromotionContestV1 {
  triggerKey: string;
  episodeUuid: string;
  rewardType: PromotionContestRewardType;
  rewardAmount: number;
  deliveryType: PromotionContestDeliveryType;
  title: string;
  message: string;
}

export interface PromotionContestV2Branch {
  id: string;
  branchName: string;
  stepIndex: number;
}

export interface PromotionContestV2Episode {
  id: string;
  episodeUuid: string;
  branches: PromotionContestV2Branch[];
}

export interface PromotionContestV2 {
  triggerIdentifier: string;
  episodes: PromotionContestV2Episode[];
  title: string;
  message: string;
  rewardType: PromotionContestRewardType;
  rewardAmount: number;
  sapphiresAmount?: number;
  heartsAmount?: number;
}

export type PromotionContestActiveSchema = 'v1' | 'v2';

export interface PromotionContestPayload {
  activeSchema: PromotionContestActiveSchema | null;
  v1: PromotionContestV1 | null;
  v2: PromotionContestV2 | null;
}

export interface PromotionContestResponse {
  success: boolean;
  contest: PromotionContestPayload;
}

export interface PromotionContestFormValues {
  activeSchema: PromotionContestActiveSchema;
  v1: PromotionContestV1;
  v2: PromotionContestV2;
}

export interface EpisodeValidationResponse {
  success: boolean;
  valid: boolean;
}
